import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M149 216v80c0 13-10 24-24 24H24c-13 0-24-11-24-24v-80c0-13 11-24 24-24h101c14 0 24 11 24 24zM0 376v80c0 13 11 24 24 24h101c14 0 24-11 24-24v-80c0-13-10-24-24-24H24c-13 0-24 11-24 24zM125 32H24C11 32 0 43 0 56v80c0 13 11 24 24 24h101c14 0 24-11 24-24V56c0-13-10-24-24-24zm80 448h283c13 0 24-11 24-24v-80c0-13-11-24-24-24H205c-13 0-24 11-24 24v80c0 13 11 24 24 24zM181 56v80c0 13 11 24 24 24h283c13 0 24-11 24-24V56c0-13-11-24-24-24H205c-13 0-24 11-24 24zm24 264h283c13 0 24-11 24-24v-80c0-13-11-24-24-24H205c-13 0-24 11-24 24v80c0 13 11 24 24 24z" })
});
export default SvgThList;
